import { Navigate } from "react-router-dom";
import AdminV2Layout from "layouts/admin-v2/layout/AdminV2Layout";
import AdminV2Dashboard from "layouts/admin-v2/dashboard/AdminV2Dashboard";
import AdminV2Account from "layouts/admin-v2/account/AdminV2Account";
import AdminV2Cardholders from "layouts/admin-v2/cardholders";
import AdminV2CreateCardholder from "layouts/admin-v2/cardholders/create";
import CustomersPage from "layouts/admin-v2/customers/CustomersPage";
import AdminV2Settings from "layouts/admin-v2/settings/AdminV2Settings";
import EnterpriseAccountsPage from "layouts/admin-v2/enterprises/EnterpriseAccountsPage";
import OrganizationAccountsPage from "layouts/admin-v2/organizations/OrganizationAccountsPage";
import WorkspaceSectionPage from "layouts/admin-v2/workspace/WorkspaceSectionPage";
import VouchersPage from "layouts/admin-v2/vouchers/VouchersPage";
import IntegrityAuditPage from "layouts/admin-v2/audit/IntegrityAuditPage";

const AdminV2Routes = [
  {
    path: "/",
    element: <Navigate to="/admin-v2" replace />,
  },
  {
    path: "/admin-v2",
    element: <AdminV2Layout />,
    children: [
      {
        index: true,
        element: <AdminV2Dashboard />,
      },
      {
        path: "account",
        element: <AdminV2Account />,
      },
      {
        path: "cardholders",
        element: <AdminV2Cardholders />,
      },
      {
        path: "cardholders/create",
        element: <AdminV2CreateCardholder />,
      },
      {
        path: "enterprises",
        element: <EnterpriseAccountsPage />,
      },
      {
        path: "organizations",
        element: <OrganizationAccountsPage />,
      },
      {
        path: "customers",
        element: <CustomersPage />,
      },
      {
        path: "vouchers",
        element: <VouchersPage />,
      },
      {
        path: "plans",
        element: (
          <WorkspaceSectionPage
            section="plans"
            title="Plans"
            description="Review plan coverage, card limits, feature allocation, and billing structure."
          />
        ),
      },
      {
        path: "subscriptions",
        element: (
          <WorkspaceSectionPage
            section="subscriptions"
            title="Subscriptions"
            description="See renewals, days left, card consumption, and accounts that need attention."
          />
        ),
      },
      {
        path: "reports",
        element: (
          <WorkspaceSectionPage
            section="reports"
            title="Reports"
            description="Surface accounts with generated reports, low capacity, or expiring subscriptions."
          />
        ),
      },
      {
        path: "admins",
        element: (
          <WorkspaceSectionPage
            section="admins"
            title="Admin Management"
            description="Track admin ownership, role coverage, webhook access, and account health."
          />
        ),
      },
      {
        path: "audit-logs",
        element: <IntegrityAuditPage />,
      },
      {
        path: "settings",
        element: <AdminV2Settings />,
      },
    ],
  },
];

export default AdminV2Routes;
